import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { registerEnsoTranslations } from '@ohpen/enso-ui';
import { CONFIG_NAMESPACE, registerConfigTranslations } from '@config';

// Initialize i18n with HTTP backend loading /locales/{{lng}}/translation.json
// Debug disabled by default; adjust if you need verbose logs locally.
const ready = i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    // `enso.*` keys PMP does not declare resolve from Enso's `enso` namespace, and `config.*` keys from
    // the configuration module's own.
    fallbackNS: ['enso', CONFIG_NAMESPACE],
    interpolation: {
      escapeValue: false,
    },
  });

registerEnsoTranslations(i18n);
registerConfigTranslations(i18n);

export default ready;
